import React, { useState } from 'react'
import { Input, Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import FolderCard from './FolderCard'
import { FolderCardSkeleton } from './AdLibrarySkeletons'
import BrandsSectionHolder from '../styles/brandsSectionStyle'

const { Search } = Input

const BrandsSection = ({ brands = [], loading = false, clientId, selectedBrand, onSelectBrand }) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  // Brand search is client-side: brands come embedded in the client, so there's
  // no endpoint — we just filter the in-memory list by name.
  const query = search.trim().toLowerCase()
  const visibleBrands = query
    ? brands.filter((b) => (b.name || '').toLowerCase().includes(query))
    : brands

  const renderEmpty = (message) => (
    <Empty
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 66, margin: 0 }}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={message}
    />
  )

  return (
    <BrandsSectionHolder>
      <div className="section-header">
        <h2>{t('Brands')}</h2>
        <Search
          placeholder={t('Search')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
        />
      </div>

      {loading ? (
          <div className="brands-list">
            {/* Render skeletons 6 times */}
            {Array.from({ length: 4 }).map((_, i) => (
              <FolderCardSkeleton key={i} />
            ))}
          </div>
        ) : !clientId
        ? renderEmpty(t('No clients available'))
        : visibleBrands.length === 0
        ? renderEmpty(t('No brands available'))
        : (
          <div className="brands-list">
            {visibleBrands.map((brand) => (
              <FolderCard
                key={brand.id}
                name={brand.name}
                image={brand.avatar}
                selected={selectedBrand === brand.id}
                onClick={() => onSelectBrand(brand.id)}
              />
            ))}
          </div>
        )}
    </BrandsSectionHolder>
  )
}

export default BrandsSection
